// 本体の既存階層はコンフリクト対策で移動しない.新しいファイルを追加する場合もそちらへ.
// TODO: 将来的にはできれば移行を検討する事.
export * from "../../../utilities";

// 今はcomponents/document/editor下だが移したいものがある.明示的に参照を書く.
// TODO: 見直せるタイミングで階層変更したい.
export {
  FileToBase64TextConverter,
} from "../../../components/document/editor/FileToBase64TextConverter";
